import React, { Component } from 'react';
import { dateFormatter, formatDecimal } from 'utils/formatter';
import styles from './List.css';

class Row extends Component {
  render() {
    const { redemption } = this.props;
    return (
      <tr
        className={`${this.props.isSelected ? styles.selected : ''}`}
        onClick={this.onClickRow}
      >
        <td className={styles.date}>{dateFormatter(redemption.created_at)}</td>
        <td className={styles.reward}>
          {redemption.reward_checkout_title || redemption.reward}
        </td>
        <td className={styles.point}>
          {formatDecimal(redemption.redeem_points)}
        </td>
      </tr>
    );
  }

  onClickRow = () => {
    this.props.onClickRow(
      this.props.redemption.payment_type.toLowerCase(),
      this.props.redemption.payment_id,
      this.props.redemption.redeem_id
    );
  };
}

export default Row;
